export default __webpack_public_path__ + "static/media/hero-wl.d44155fd.png";